var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound84BSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 62 62",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 31,
  r: 13,
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M26 3h10l.752 8.274A2.5 2.5 0 0 1 34.262 14h-6.524a2.5 2.5 0 0 1-2.49-2.726L26 3Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m25 5 .223-.445A2.813 2.813 0 0 1 27.738 3h6.524c1.065 0 2.039.602 2.515 1.555L37 5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M36 59H26l-.752-8.274A2.5 2.5 0 0 1 27.738 48h6.524a2.5 2.5 0 0 1 2.49 2.726L36 59Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m37 57-.223.445A2.813 2.813 0 0 1 34.262 59h-6.524a2.813 2.813 0 0 1-2.515-1.555L25 57"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m14.736 54.334-7.07-7.07 5.318-6.383a2.5 2.5 0 0 1 3.688-.167l4.614 4.614a2.5 2.5 0 0 1-.168 3.688l-6.382 5.319Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m16.858 53.627-.473.158a2.812 2.812 0 0 1-2.878-.68l-4.613-4.612a2.813 2.813 0 0 1-.68-2.879l.158-.472"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m47.264 7.665 7.07 7.071-5.318 6.383a2.5 2.5 0 0 1-3.688.167l-4.614-4.614a2.5 2.5 0 0 1 .168-3.688l6.382-5.319Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m45.142 8.373.473-.158a2.813 2.813 0 0 1 2.878.68l4.613 4.612a2.812 2.812 0 0 1 .68 2.879l-.158.472"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3 36V26l8.274-.752A2.5 2.5 0 0 1 14 27.738v6.524a2.5 2.5 0 0 1-2.726 2.49L3 36Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m5 37-.445-.223A2.813 2.813 0 0 1 3 34.262v-6.524c0-1.065.602-2.039 1.555-2.515L5 25"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M59 26v10l-8.274.752A2.5 2.5 0 0 1 48 34.262v-6.524a2.5 2.5 0 0 1 2.726-2.49L59 26Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m57 25 .445.223A2.813 2.813 0 0 1 59 27.738v6.524c0 1.065-.602 2.039-1.555 2.515L57 37"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m7.666 14.737 7.07-7.071 6.383 5.318a2.5 2.5 0 0 1 .167 3.688l-4.614 4.614a2.5 2.5 0 0 1-3.688-.167l-5.318-6.382Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m8.373 16.858-.158-.472a2.812 2.812 0 0 1 .68-2.878l4.613-4.613a2.812 2.812 0 0 1 2.878-.68l.472.158"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m54.334 47.263-7.07 7.071-6.383-5.318a2.5 2.5 0 0 1-.167-3.688l4.614-4.614a2.5 2.5 0 0 1 3.688.167l5.318 6.382Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m53.627 45.142.158.472a2.812 2.812 0 0 1-.68 2.879l-4.613 4.612a2.812 2.812 0 0 1-2.878.68l-.472-.158"
})));
SvgRound84BSelected.viewBox = '0 0 62 62';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound84BSelected);
export default ForwardRef;